import { HttpResponse, ajax } from '../../../../common/ajax';
import { config } from '../../config';
import {
  CheckoutResponseModel,
  InvoicingAddressModel,
} from '../../models/Checkout';

interface ICheckoutService {
  checkout: (
    sessionId: string,
    checkoutMethodCode: string,
    invoicingAddress: InvoicingAddressModel | null,
  ) => Promise<HttpResponse<CheckoutResponseModel>>;
}

export const checkoutService: ICheckoutService = {
  checkout(sessionId, checkoutMethodCode, invoicingAddress) {
    return ajax.post<CheckoutResponseModel>(
      `${config.benefitApiUrl}/checkout`,
      {
        sessionId,
        checkoutMethodCode,
        invoicingAddress,
      },
    );
  },
};
